import { render, staticRenderFns } from "./LayoutDefaultSideBar.vue?vue&type=template&id=5a8fb5da&"
import script from "./LayoutDefaultSideBar.vue?vue&type=script&lang=js&"
export * from "./LayoutDefaultSideBar.vue?vue&type=script&lang=js&"
import style0 from "./LayoutDefaultSideBar.vue?vue&type=style&index=0&id=5a8fb5da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports